var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.418,
    height: 25.381,
    viewBox: "0 0 25.418 25.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D84FLm.tif",
    transform: "translate(6130.305 -3968.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4913",
    "data-name": "Group 4913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    "data-name": "Path 7366",
    d: "M-6117.585,3968.3a12.767,12.767,0,0,1,12.7,12.71,12.725,12.725,0,0,1-12.8,12.671,12.728,12.728,0,0,1-12.617-12.695A12.764,12.764,0,0,1-6117.585,3968.3Zm-.029,19.023c1.455,0,2.911-.01,4.366.006.56.006.859-.222.844-.788a18.146,18.146,0,0,0-.115-2.371,3.5,3.5,0,0,0-3.238-2.894c-1.213-.06-2.434-.059-3.648,0a3.5,3.5,0,0,0-3.277,2.943,20.413,20.413,0,0,0-.113,2.212c-.03.63.243.914.9.9C-6120.471,3987.307-6119.042,3987.324-6117.614,3987.323Zm0-7.164a3.161,3.161,0,0,0,3.163-3.1,3.16,3.16,0,0,0-3.173-3.171,3.155,3.155,0,0,0-3.122,3.141A3.157,3.157,0,0,0-6117.612,3980.159Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9ecbb43fc7c9ecb3af096891a07bc8bc.svg";
export { ForwardRef as ReactComponent };